import { render } from "./DataMigration.vue?vue&type=template&id=4cb6104d"
import script from "./DataMigration.vue?vue&type=script&lang=js"
export * from "./DataMigration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__